export default __webpack_public_path__ + "static/1549-824ea0108b2d48e3e97c0ddc53f8bd2a.gif";